import { render, staticRenderFns } from "./orderPrinter.vue?vue&type=template&id=5db4be0c&scoped=true"
import script from "./orderPrinter.vue?vue&type=script&lang=js"
export * from "./orderPrinter.vue?vue&type=script&lang=js"
import style0 from "./orderPrinter.vue?vue&type=style&index=0&id=5db4be0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db4be0c",
  null
  
)

export default component.exports